import {useEffect} from 'react'
import {useParams} from "react-router-dom"
import {logger}    from "../../util/log-utils"

const log = logger("PackageDetail", 1)

const PackageDetail = ({
	                     // Direct props when used as a child component
	                     categoryToken: propsCategoryToken,
	                     packageToken: propsPackageToken,
	                     prepKit,
                     }) => {

	const {categoryToken, packageToken} = useParams()

	useEffect(() => {
		if (!categoryToken || !packageToken) return
		const url = `${process.env.REACT_APP_WEB_URL}/${categoryToken}/${packageToken}`
		window.location.href = url
	}, [categoryToken, packageToken])

}

export default PackageDetail
